module.exports = __webpack_public_path__ + "static/img/Hamish_Hartlett_mobile.611c380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamish_Hartlett_mobile.jpg
// module id = Sc8H
// module chunks = 0